module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dictionaryItems":{"id":"ID","code":"Code","name":"Name"}},"ru":{"dictionaryItems":{"id":"ID","code":"Код","name":"Наименование"}}}')
  delete Component.options._Ctor
}
